export { default } from './how-to-buy';